<template>
    <div class="animated fadeIn">
        <spinner v-if="loading"/>
        <b-card>
            <div slot="header">
                <strong>Search GRI</strong>
            </div>
            <b-row>
                <b-col sm="3">
                    <b-form-group>
                        <label for="gro_num">GRI No</label>
                            <b-form-input type="text" id="gri_num" v-model="filter.gri_num"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="3">
                        <b-form-group>
                            <label for="country_id">Country</label>
                            <countryLookup v-bind:url="apiCountryLookup" v-on:selected="setCountry($event)" :lookupId="filter.country_id"/>
                        </b-form-group>
                </b-col>
                <b-col sm="3">
                    <b-form-group>
                        <label>Date Start</label>
                            <b-form-input type="date" v-model="filter.date_start"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="3">
                    <b-form-group>
                        <label>Date End</label>
                            <b-form-input type="date" v-model="filter.date_end"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="footer">
                <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
                &nbsp;&nbsp;
                <b-button type="submit" size="lg" variant="success" @click="newGri">New GRI</b-button>
          </div>
      </b-card>
      <b-row v-if="getRowCount(searchResults) > 0 && !loading">
        <b-col sm="12">
          <b-card>
              <div slot="header">
                  <strong>Search Results</strong>
              </div>
              <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :current-page="currentPage" 
              :per-page="perPage" :items="searchResults"  @row-clicked="rowClick">
              </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
            <div slot="footer">
                <exportExcel
                  class   = "btn btn-primary btn-lg"
                  size ="lg"
                  :data   = "searchResults"
                  :fields = "exportHeaders"
                  name    = "gri.xls">
                  Export to Excel
              </exportExcel>
              &nbsp;&nbsp;
              <b-button type="button" size="lg" variant="success" @click="print">Print</b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-else-if="noResults" >
            <b-col sm="12">
              <div align="center">
                <strong>No GRI Found</strong>
              </div>                    
            </b-col>
        </b-row>
      </div>
    </template>
    <script>
    import spinner from '@/components/Spinner.vue'
    import {apiGriSearch} from '@/functions/common.vue'
    import countryLookup from '@/components/Autocomplete.vue'
    import {authHeader, apiCountryLookup} from '@/functions/common.vue'
    import axios from 'axios'
    import exportExcel from 'vue-json-excel'
    
    import pdfMake from "pdfmake/build/pdfmake";
    import pdfFonts from "pdfmake/build/vfs_fonts";
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake.fonts = {
        "ukai": {
          normal: 'ukai.ttf',
            bold: 'ukai.ttf',
            italics: 'ukai.ttf',
            bolditalics: 'ukai.ttf'
        },
    };
    export default
    {
      components:{spinner,countryLookup,exportExcel},
      props: 
      {
        hover: {
          type: Boolean,
          default: false
        },
        striped: {
          type: Boolean,
          default: false
        },
        bordered: {
          type: Boolean,
          default: false
        },
        small: {
          type: Boolean,
          default: false
        },
        fixed: {
          type: Boolean,
          default: false
        }
      },
      data () {
      return {
        loading: false,
        seen :false,
        searchResults: [],
        apiCountryLookup: apiCountryLookup,
        noResults: false, 
        filter: {
          gri_num: '',
          country_id: '',
          date_start: '',
          date_end: ''
        }, 
        exportHeaders:
            {
              'Country': 'country_id',
              'Location': 'location_id',
              'Date': 'gri_date',
              'GRI No': 'gri_num',
              'Supplier':'supplier_name',
              'Remarks':'remarks',
              'Created By':'user_shortname'
            }, 
        searchResultsFields: [
          {key: 'country_id', label: 'Country'},
          {key: 'location_id' ,label: 'Location'},
          {key: 'gri_date' ,label: 'Date'},
          {key: 'gri_num' ,label: 'GRI No'},
          {key: 'supplier_name' ,label: 'Supplier'},
          {key: 'remarks' ,label: 'Remarks'},
          {key: 'user_shortname' ,label: 'Created By'}
        ],
        currentPage: 1,
        perPage: 20,
        totalRows: 0,
        noResults: false
      }
      },
      methods:
      {
        print()
            {
              var rows = []
              var row = []
              var date = new Date();
              rows.push([
              'Country',
              'Location',
              'Date',
              'GRI No',
              'Supplier',
              'Remarks',
              'Created By'
              ])
    
              for (let key in this.searchResults)
              {
                var data = this.searchResults[key]
                row = [
                data.country_id, 
                data.location_id, 
                data.gri_date, 
                data.gri_num, 
                data.supplier_name, 
                data.remarks,
                data.user_shortname]
                rows.push(row)
              }
              var dd = {
                header:{ text: 'Goods Return Inwards List generated on'+ " "+ date, margin: [ 5, 10, 10, 20 ],alignment: 'center',fontSize:8 },
                pageSize: 'A4',
                pageOrientation: 'portrait',
              
                // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                pageMargins: [30, 30, 30, 20 ],
                defaultStyle: {
                  font: 'ukai'
                },
                content: [
                  {
                    fontSize: 8,
                    layout: 'lightHorizontalLines', // optional
                    table: {
                      headerRows: 1,
                      widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
    
                      body: 
                        rows
                      
                    }
                  }
                ]
              };
    
              pdfMake.createPdf(dd).open();
            },
        getRowCount (list) 
        {
            return list.length
        },
        rowClick(item, index)
        { 
            this.$router.push({ name: 'Goods Return Inwards Entry (GRI)', params: { griNum: item.gri_num }}) 
        },
        newGri()
        {
          this.$router.push({ name: 'Goods Return Inwards Entry (GRI)', params: { griNum: '_new' }})
        },
        search()
        {
          this.loading = true
          this.seen =true
          var sf =
            [
              "gri_num LIKE " + this.filter.gri_num
              ,"country_id = " + this.filter.country_id
              ,"gri_date >= " + this.filter.date_start
              ,"gri_date <= " + this.filter.date_end
            ]   
                if(1)
                {
                    axios.post(apiGriSearch, sf,authHeader())
                    .then (res => 
                    {
                        return res
                    })
                    .then (data =>
                    {
                        const resultArray = []
                        const myData = data.data.data.list
                        for (let key in myData)
                        {
                            var date = myData[key].gri_date
                            var date = new Date(date);
                            var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                            myData[key].gri_date = result
                            resultArray.push(myData[key])
                            this.loading = false
                        }
                        this.searchResults = resultArray
                        
                        if(this.searchResults.length ==0)
                        {
                            this.loading = false
                            this.noResults =true
                        }
                    })
                    .catch(error => console.log(error))

                }     
        },
        setCountry(obj)
        {
              var id
              if (obj !== null)
              {
                id = obj.id
              } 
              else
              {
                id = null
              }
              this.filter.country_id = id
        }
      }
    }
    </script>
    <style>
        .main {overflow-x: overlay;overflow-y: overlay;overflow:hidden;}
    </style>


// WEBPACK FOOTER //
// src/views/gri/gris.vue